import { BackgroundContainer } from "../BackgroundContainer";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";

    export class InstructionsState extends Phaser.State {

        public static currentInstance: InstructionsState;  

        private pages: Phaser.Group[];
        private counter: number;
        private enterKey: Phaser.Key;
        private spaceKey: Phaser.Key;

        public init(): void {
            
            InstructionsState.currentInstance = this;
        }
        
        public create(): void {

            const background = new BackgroundContainer(this.game);
            this.add.existing(background);

            const darkLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
            darkLayer.scale.set(GameConstants.GAME_WIDTH / GameConstants.BITMAP_SIZE, GameConstants.GAME_HEIGHT / GameConstants.BITMAP_SIZE);
            darkLayer.inputEnabled = true;
            darkLayer.events.onInputDown.add(this.nextPage, this);
            darkLayer.alpha = .65;

            this.pages = [];
            this.counter = 0;

            let onDesktop = !/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent);

            let s =  window.innerWidth / window.innerHeight <= 1.5 && !onDesktop ? .75 : 1;

            for (let i = 0; i < 3; i++) {

                const container = new Phaser.Group(this.game);
                container.x = GameConstants.GAME_WIDTH / 2;
                container.scale.set(s * GameVars.scaleX, s);
                this.add.existing(container);
                this.pages.push(container);
            }

            // PAGE 1

            let text = "Get as many chickens across the street as you can. \n\n Cars colliding with you at high speeds will hurt. \n\n Caution is key, but don't take too long. Your \n score will depend on the time you spent crossing.";

            const textPage1 = new Phaser.Text(this.game, 0, GameConstants.GAME_HEIGHT / 2, text, {font: "25px RoundsBlack", fill: "#FFFFFF", align: "center"});
            textPage1.anchor.set(.5);
            textPage1.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.pages[0].add(textPage1);

            // PAGE 2

            text = "Jumping at the right moment could mean \n the difference between life and death.";

            const textPage2 = new Phaser.Text(this.game, 0, GameConstants.GAME_HEIGHT / 2, text, {font: "25px RoundsBlack", fill: "#FFFFFF", align: "center"});
            textPage2.anchor.set(.5);
            textPage2.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.pages[1].add(textPage2);
            this.pages[1].visible = false;

            // PAGE 3
            
            let feather = new Phaser.Image(this.game, 0, 280, "texture_atlas_1", "feather.png");
            feather.anchor.set(.5);
            this.pages[2].add(feather);

            text = "Feathers will give you a speed boost \n for a short time.";

            const textPage4 = new Phaser.Text(this.game, 0, GameConstants.GAME_HEIGHT / 2 - 50, text, {font: "25px RoundsBlack", fill: "#FFFFFF", align: "center"});
            textPage4.anchor.set(.5);
            textPage4.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.pages[2].add(textPage4);
            this.pages[2].visible = false;

            if (!/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) {
                this.createInputs();
            }
        }

        public shutdown(): void {
            
            InstructionsState.currentInstance = null;
            
            super.shutdown();
        }

        private createInputs(): void {

            this.enterKey = this.game.input.keyboard.addKey(Phaser.Keyboard.ENTER);
            this.spaceKey = this.game.input.keyboard.addKey(Phaser.Keyboard.SPACEBAR);

            this.enterKey.onDown.add(this.nextPage, this);
            this.spaceKey.onDown.add(this.nextPage, this);
        }

        private nextPage(): void {

            AudioManager.playSound("click");

            this.counter++;

            if (this.counter === 3) {
                GameManager.enterSplashScene();
            } else {
                for (let i = 0; i < 3; i++) {
                    if (this.counter === i) {
                        this.pages[i].visible = true;
                    } else {
                        this.pages[i].visible = false;
                    }
                }
            }
        }
    }
